export const SET_ACTIVE_MENU = "SET_ACTIVE_MENU";
export const SET_ACTIVE_CHILD_MENU = "SET_ACTIVE_CHILD_MENU ";
export const GET_ACTIVE_MENU = "GET_ACTIVE_MENU";
export const CLEAR_ACTIVE_MENU = "CLEAR_ACTIVE_MENU";
